
import { MachineConfig } from "xstate";

export interface CandidateProfileSchema {
    states: {
        initial: {},
        draft: {},
        submitted: {},
        approved: {},
        rejected: {},
        inprogress: {},
        invited: {},
        cancelledInvite: {},


    }
}

export interface CandidateProfileContext {

}

export class SAVE {
    readonly type = 'SAVE';
}
export class SUBMIT {
    readonly type = 'SUBMIT';
}
export class APPROVE {
    readonly type = 'APPROVE';
}
export class REJECT {
    readonly type = 'REJECT';
}
export class CANCELINVITE {
    readonly type = 'CANCELINVITE';
}
export class SENDINVITE {
    readonly type = 'SENDINVITE';
}
export class RESENDINVITE {
    readonly type = 'RESENDINVITE';
}


export type CandidateProfileSmEvents = SAVE | SUBMIT | APPROVE | REJECT | CANCELINVITE | SENDINVITE | RESENDINVITE;


export const CandidateProfileMachineConfig: MachineConfig<CandidateProfileContext, CandidateProfileSchema, CandidateProfileSmEvents> =
{
    key: 'candidate-profile-sm',
    initial: 'initial',
    states: {
        initial: {
            on: {
                SAVE: [{
                    target: 'draft',
                    cond: 'isRecruiter'
                }],
                SUBMIT: [{
                    target: 'submitted',
                    cond: 'isRecruiter'
                }],
                SENDINVITE:
                    [{
                        target: 'invited',
                        cond: 'isInvite'
                    }],
            }
        },
        draft: {
            on: {
                SAVE: [{
                    target: 'draft',
                    actions: [(a, b) => { }],
                    cond: 'isRecruiter'
                }],
                SUBMIT: [{
                    target: 'submitted',
                    cond: 'isRecruiter'
                }],

                SENDINVITE:
                    [{
                        target: 'inprogress',
                        cond: 'isInvite'
                    }],
            }
        },
        submitted: {
            on: {
                APPROVE: [{
                    target: 'approved',
                    cond: 'canApprove'
                }],
                REJECT: [{
                    target: 'rejected',
                    cond: 'canReject'
                }]
            }
        },
        approved: {
            on: {
                REJECT: [{
                    target: 'rejected',
                    cond: 'canReject'
                }],
                SAVE: [{
                    target: 'inprogress',
                    cond: 'isPTC'
                }]
            }
        },
        rejected: {
            on: {
                SAVE: [{
                    target: 'draft',
                    cond: 'isRecruitedAndNotInvited'
                }],
                SUBMIT: [{
                    target: 'submitted',
                    cond: 'isRecruiterReject'
                }],

                RESENDINVITE: [{
                    target: 'invited',
                    cond: 'isInvite'
                }],
                CANCELINVITE: [{
                    target: 'cancelledInvite',
                    cond: 'isInvite'
                }]
            }
        },
        invited: {
            on: {
                RESENDINVITE: [{
                    target: 'invited',
                    actions: [(a, b) => { }],
                    cond: 'isInvite'
                }],
                CANCELINVITE: [{
                    target: 'cancelledInvite',
                    cond: 'isInvite'
                }]
            }
        },
        cancelledInvite: {
            on: {
                SAVE: [{
                    target: 'draft',
                    cond: 'isInvite'
                }],
                SENDINVITE:
                    [{
                        target: 'invited',
                        cond: 'isInvite'
                    }],
            }
        },
        inprogress: {
            type: 'final'
        },

    }
};

